import { useEffect, useState, useMemo, useRef } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import 'ag-grid-enterprise';
import ConfirmDeleteModal from "../confirmdeletemodal";
import loaderGif from "../../../assets/loader.gif";
import api from '../../../config/axiosConfig';
import pdfIcon from "../../../assets/pdf-icon.png";

// import dayjs from 'dayjs';

const Residential = () => {
    const [formData, setFormData] = useState({  // To store user input
        name: '',
        label: '',
        description: '',
        intercom: '',
        bedrooms: '',
        bathrooms: '',
        livingrooms: '',
        standardOccupancy: '',
        extraBedCapacity: '',
        doubleSofaBed: '',
        singleSofaBed: '',
        isactive: true, // Default to true,
        residenceMedia: '',
        amenityChargeFactor: ''
    });
    const [isEditMode, setIsEditMode] = useState(false); // To track if we are in edit mode
    // const [categories, setCategories] = useState();
    // const [itemtypes, setItemTypes] = useState();
    // const [filteredCategories, setFilteredCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [loader, setLoader] = useState(false);
    const gridRef = useRef();
    const [residentialType, setresidentialType] = useState();
    const [RowData, setRowData] = useState();
    const [files, setFiles] = useState([]);

    const getData = async () => {
        try {
            const response = await api.get('/residential');
            const residentialType = await api.get('/residentialTypes');
            setresidentialType(residentialType.data)

            //  const response = await api.get('/itemTypes');
            //  const categories = await api.get('/categories')
            setRowData(Array.isArray(response.data) ? response.data : []);
            //  setItemTypes(itemtypes.data)
            //  setCategories(categories.data)
            // console.log("response is", response)
            gridRef.current.api.setServerSideDatasource(datasource);
        } catch (error) {
            console.log("error for fetching the data", error);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const handleFileChange = (e) => {
        setFiles(Array.from(e.target.files)); // Capture the selected file
    };

    const columnDefs = [
        { headerName: 'ID', field: 'id', sort: "desc", filter: 'agNumberColumnFilter' },
        { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter' },
        { headerName: 'Residential Type', field: 'residentialTypeId', filter: 'agNumberColumnFilter' },

        {
            headerName: 'Residence Media',
            field: 'residenceMedia',
            cellRenderer: (params) => {
                const filePath = params.data.path ? params.data.path.replace('uploads/residentialFiles/', '') : '';

                const mediaUrl = `${process.env.REACT_APP_WS_URL}/api/residential/residentialFiles${filePath}`;
                if (!filePath || mediaUrl === `${process.env.REACT_APP_WS_URL}/api/residential/residentialFiles`) {
                    return (
                        <div style={{ textAlign: 'center', color: 'gray' }}>
                            No Media Present
                        </div>
                    );
                }

                // Check if the media URL is a video
                const isVideo = mediaUrl && (mediaUrl.includes('.mp4') || mediaUrl.includes('.webm'));

                if (isVideo) {
                    // Video renderer
                    return (
                        <video
                            src={mediaUrl}
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                            muted
                        />
                    );
                } else if (mediaUrl.includes('.pdf')) {
                    // PDF renderer
                    return (
                        <a href={mediaUrl} target="_blank" rel="noopener noreferrer">
                            <img
                                src={pdfIcon}
                                alt="PDF"
                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                            />
                        </a>
                    );
                } else {
                    // Image renderer
                    return (
                        <img
                            src={mediaUrl}
                            alt="media"
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                        />
                    );
                }
            },
        },

        { headerName: 'Label', field: 'label', filter: 'agTextColumnFilter', filter: 'agTextColumnFilter' },
        { headerName: 'Description', field: 'description', filter: 'agTextColumnFilter' },
        { headerName: 'Intercom', field: 'intercom', filter: 'agNumberColumnFilter' },
        { headerName: 'Bedrooms', field: 'bedrooms', filter: 'agNumberColumnFilter' },
        { headerName: 'Bathrooms', field: 'bathrooms', filter: 'agNumberColumnFilter' },
        { headerName: 'Living Rooms', field: 'livingrooms', filter: 'agNumberColumnFilter' },
        { headerName: 'Standard Occupancy', field: 'standardOccupancy', filter: 'agNumberColumnFilter' },
        { headerName: 'Extra Bed Capacity', field: 'extraBedCapacity', filter: 'agNumberColumnFilter' },
        { headerName: 'Double Sofa Bed', field: 'doubleSofaBed', filter: 'agNumberColumnFilter' },
        { headerName: 'Single Sofa Bed', field: 'singleSofaBed', filter: 'agNumberColumnFilter' },
        { headerName: 'amenityChargeFactor', field: 'amenityChargeFactor', filter: 'agNumberColumnFilter' },
        { headerName: 'Is Active', field: 'isactive' },
        { headerName: 'Created At', field: 'createddate', filter: 'agDateColumnFilter' },
        { headerName: 'Updated At', field: 'modifieddate', filter: 'agDateColumnFilter' },
        {
            field: "actions",
            headerName: "Actions",
            cellRenderer: (params) => (
                <Button
                    variant="danger"
                    className="btn-sm"
                    onClick={() => handleDelete(params.data)}
                >
                    <i class="bi bi-trash3"></i>
                </Button>
            ),
        },
        // Add more columns as needed
    ];

    const sideBar = useMemo(() => {
        return {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                }
            ],
            defaultToolPanel: '',
        };
    }, []);

    // Server-Side Datasource
    const datasource = {
        getRows: async function (params) {
            try {
                const { request } = params;

                const response = await api.post('/residential/ag', { ...request });

                const { rows, lastRow } = response.data;

                // Send data back to AG Grid
                params.successCallback(rows, lastRow);
            } catch (error) {
                console.error("Error fetching rows:", error);
                params.failCallback();
            }
        }
    };

    const gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: columnDefs,

        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            filterParams: {
                buttons: ["reset"],
                closeOnApply: true,
            },
        },

        sideBar: sideBar,
        rowGroupPanelShow: 'always',
        rowSelection: 'single',
        columnHoverHighlight: true,
        suppressRowGroupHidesColumns: true,
        cacheBlockSize: 20,
    }

    // Attach the datasource when the grid is ready
    const onGridReady = (params) => {
        params.api.setServerSideDatasource(datasource);
    };

    // const handleItemTypeChange = (e) => {
    //     const selectedItemTypeId = Number(e.target.value); // Get the selected item type ID
    //     setFormData({ ...formData, itemtypeid: selectedItemTypeId });

    //     // Filter categories based on the selected item type
    //     const filtered = categories.filter(category => category.itemTypeId == selectedItemTypeId);
    //     setFilteredCategories(filtered); // Set the filtered categories
    //     // console.log("Filtered categories:", filtered); 
    // };

    // Row selection handler
    const onRowSelected = (event) => {
        if (event.node.isSelected()) {

            const selectedData = event.data;

            // const formattedOrderNoticePeriod = selectedData.ordernoticeperiod
            // ? dayjs(selectedData.ordernoticeperiod, 'HHmm').format('HH:mm')
            // : ''; // Default to an empty string if undefined or null
            // const selectedData = event.data;

            setFormData({
                id: selectedData.id,
                name: selectedData.name,
                residentialTypeId: selectedData.residentialTypeId,
                label: selectedData.label || '',
                description: selectedData.description,
                intercom: selectedData.intercom,
                bedrooms: selectedData.bedrooms,
                bathrooms: selectedData.bathrooms,
                livingrooms: selectedData.livingrooms,
                standardOccupancy: selectedData.standardOccupancy,
                extraBedCapacity: selectedData.extraBedCapacity,
                doubleSofaBed: selectedData.doubleSofaBed,
                singleSofaBed: selectedData.singleSofaBed,
                residenceMedia: selectedData.residenceMedia,
                amenityChargeFactor: selectedData.amenityChargeFactor,
                isactive: selectedData.isactive
            });
            setIsEditMode(true);
            setSelectedRow(selectedData)
        }
    };

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value // Handle checkbox separately
        }));
    };

    // Handle form submission to save data to Firestore
    const handleAddData = async (e) => {
        e.preventDefault();
        if (formData.name) {
            try {
                let mediaPath = '';
                if (files.length) {
                    const uploadFormData = new FormData();
                    files.forEach((file) => uploadFormData.append('file', file));
                    const uploadResponse = await api.post('/residential/uploads', uploadFormData);
                    mediaPath = uploadResponse.data.filePath; // Extract the uploaded file path
                }

                const url = isEditMode ? `/residential/${formData.id}` : '/residential';
                const method = isEditMode ? 'put' : 'post';
                // Make the Axios call using the api instance
                await api({
                    method,
                    url,
                    data: {
                        name: formData.name || null,
                        residentialTypeId: formData.residentialTypeId || null,
                        label: formData.label || null,
                        description: formData.description || null,
                        intercom: formData.intercom || null,
                        bedrooms: formData.bedrooms || null,
                        bathrooms: formData.bathrooms || null,
                        livingrooms: formData.livingrooms || null,
                        standardOccupancy: formData.standardOccupancy || null,
                        extraBedCapacity: formData.extraBedCapacity || null,
                        doubleSofaBed: formData.doubleSofaBed || null,
                        singleSofaBed: formData.singleSofaBed || null,
                        isactive: formData.isactive || false, // Default to false if empty
                        residenceMedia: mediaPath,
                        amenityChargeFactor:formData.amenityChargeFactor || null
                    }
                    //    console.log("data is ", data);
                })

            } catch (error) {
                console.error('Error:', error);
            }
            // Clear the form
            setFormData({ id: null, name: '', residentialTypeId: '', description: '', intercom: '', bedrooms: '', bathrooms: '', livingrooms: '', standardOccupancy: '', extraBedCapacity: '', doubleSofaBed: '', singleSofaBed: '', isactive: true, residenceMedia: '', amenityChargeFactor: '' });
            setIsEditMode(false); // Reset to add mode
            gridRef.current.api.refreshServerSideStore({ purge: true });
        } else {
            alert("Please fill out the name field.");
        }
    };

    // Reset form for new entry
    const handleNewEntry = () => {
        setFormData({ id: null, name: '', residentialTypeId: '', label: '', description: '', intercom: '', bedrooms: '', bathrooms: '', livingrooms: '', standardOccupancy: '', extraBedCapacity: '', doubleSofaBed: '', singleSofaBed: '', isactive: true, residenceMedia: '', amenityChargeFactor: '' });
        setIsEditMode(false);  // Switch to add mode
    };

    const handleDelete = (category) => {
        setSelectedRow(category); // Store the category to be deleted
        setShowModal(true); // Show the modal
    };

    const confirmDelete = async () => {
        if (selectedRow) {
            try {
                await api.delete(`/residential/${selectedRow.id}`);
                setShowModal(false);
                gridRef.current.api.refreshServerSideStore({ purge: true });
            } catch (error) {
                console.error('Error deleting item:', error);
            }
        }
    };
    
    return (
        <>
            <Container fluid>
                {/* Category List */}
                <Row className="mt-4">
                    <h6 className="text-start">Residential List</h6>
                    <div className="ag-theme-alpine" style={{ height: 400, width: '70%' }}>
                        <AgGridReact
                            ref={gridRef}
                            gridOptions={gridOptions}
                            onGridReady={onGridReady}
                            onRowSelected={onRowSelected}
                        />
                    </div>
                    <div style={{ width: '30%', height: '400px', border: '1px solid grey' }}>
                        {selectedRow && selectedRow.path ? (
                            selectedRow.path.includes('.mp4') || selectedRow.path.includes('.webm') ? (
                                <video
                                    src={`${process.env.REACT_APP_WS_URL}/api/residential/residentialFiles${selectedRow.path.replace('uploads/residentialFiles/', '')}`}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '5px' }}
                                    controls
                                />
                            ) : selectedRow.path.includes('.pdf') ? (
                                <iframe
                                    src={`${process.env.REACT_APP_WS_URL}/api/residential/residentialFiles${selectedRow.path.replace('uploads/residentialFiles/', '')}`}
                                    style={{ width: '100%', height: '100%', borderRadius: '5px' }}
                                    title="PDF Viewer"
                                />
                            ) : (
                                <img
                                    src={`${process.env.REACT_APP_WS_URL}/api/residential/residentialFiles${selectedRow.path.replace('uploads/residentialFiles/', '')}`}
                                    alt="media"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '5px' }}
                                />
                            )
                        ) : null}
                    </div>
                </Row>
                <Row className="mt-4 border shadow p-4">
                    {loader && (
                        <div className="loader-overlay">
                            <img src={loaderGif} alt="Loading..." className="loader" />
                        </div>
                    )}
                    <h6 className="text-start">Add Residential</h6>
                    <Form onSubmit={handleAddData}>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="me-3">Name:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Enter category name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        name="isactive"
                                        label="Is Active"
                                        checked={formData.isactive}
                                        onChange={handleChange}
                                        className="ms-4"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Residential Types</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            as="select"
                                            name="residentialTypeId"
                                            value={formData.residentialTypeId}
                                            onChange={handleChange}
                                            required>

                                            <option value="">Select Residential Type</option>


                                            {residentialType && residentialType.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </InputGroup>
                                </Form.Group>

                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label> Description</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            as="textarea"
                                            name="description"
                                            placeholder="Enter Description"
                                            value={formData.description}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Label</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="label"
                                            placeholder="Enter Label"
                                            value={formData.label}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Intercom<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="intercom"
                                            placeholder="Enter intercom"
                                            value={formData.intercom}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                        </Row>

                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Bedrooms<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="bedrooms"
                                            placeholder="Enter Number Of Bedrooms"
                                            value={formData.bedrooms}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Bathrooms<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="bathrooms"
                                            placeholder="Enter Number Of Bathrooms"
                                            value={formData.bathrooms}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>


                        </Row>

                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Leaving Rooms<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="livingrooms"
                                            placeholder="Enter Number Of Leaving Rooms"
                                            value={formData.livingrooms}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Standard Occupancy <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="standardOccupancy"
                                            placeholder="Enter Standard Occupancy"
                                            value={formData.standardOccupancy}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col md={6}>
                            <Form.Group>
                                    <Form.Label>Extra Bed Occupancy <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="extraBedCapacity"
                                            placeholder="Enter Extra Bed Occupancy"
                                            value={formData.extraBedCapacity}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Double Sofa bed <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="doubleSofaBed"
                                            placeholder="Enter Number Of Double Sofa bed"
                                            value={formData.doubleSofaBed}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>


                        </Row>

                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Single Sofa bed <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="singleSofaBed"
                                            placeholder="Enter Number Of Single Sofa bed"
                                            value={formData.singleSofaBed}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col>
                                {/* File Input for Media Upload */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Upload Photos/Videos</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                        <Col md={6}>
                                <Form.Group>
                                    <Form.Label>amenityChargeFactor <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="amenityChargeFactor"
                                            placeholder="Enter amenityChargeFactor"
                                            value={formData.amenityChargeFactor}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Button variant="primary" type="submit" className="mt-4">
                            {isEditMode ? "Update" : "Add"}
                        </Button>
                        {isEditMode ?
                            <Button variant="secondary" className="ms-3 mt-4" onClick={handleNewEntry}>
                                Create New Entry
                            </Button>
                            : ''
                        }
                    </Form>
                </Row>
            </Container>

            {/* Modal for confirming deletion */}
            <ConfirmDeleteModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={confirmDelete}
                title="Confirm Deletion"
                body={`Are you sure you want to delete ${selectedRow?.name}?`}
                confirmText="Delete"
            />

        </>
    );
};

export default Residential


